// extracted by mini-css-extract-plugin
module.exports = {"barContainer":"styles_barContainer__MlMhg","bar":"styles_bar__WCloT","barBg":"styles_barBg__LJQ78","label":"styles_label__pU1Q_"};